var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-aos":"fade-right"}},[(_vm.templateNumber === 1)?_c('ImageSlider1',{attrs:{"section":_vm.section}}):(_vm.templateNumber === 2)?_c('ImageSlider2',{attrs:{"section":_vm.section}}):(_vm.templateNumber === 3)?_c('ImageSlider4',{attrs:{"section":_vm.section}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }